import React from 'react';
import { AttributeGraphNode, AttributeGraphLink } from './attribute.types';
import { nodeColor, nodeRadius } from './attribute.constants';
import { ForceNetworkGraph } from '../../../../components/NetworkGraph/ForceNetworkGraph';

interface Props {
  nodes: AttributeGraphNode[];
  links: AttributeGraphLink[];
  onNodeClick: (node: AttributeGraphNode) => void;
  rootId?: string;
  height?: number;
}

// Thin domain wrapper over the shared ForceNetworkGraph: all layout machinery
// (position cache, forces, root pinning, drag-to-pin, pendingState styling)
// lives in the shared component; only colors/radii/labels are ours.
// Attribute options are meaningless without their group (e.g. "Indoor" →
// Environment), so the value label carries its parent attribute as a caption.
export const AttributeGraph: React.FC<Props> = ({ nodes, links, onNodeClick, rootId, height = 520 }) => (
  <ForceNetworkGraph<AttributeGraphNode>
    nodes={nodes}
    links={links}
    nodeColor={(n) => nodeColor(n.type)}
    nodeRadius={(n) => nodeRadius(n.type)}
    nodeLabel={(n) => ({
      text: n.name || '',
      bold: n.type === 'attribute_value',
      caption:
        n.type === 'attribute_value' && n.attributeName ? n.attributeName : undefined,
    })}
    onNodeClick={onNodeClick}
    rootId={rootId}
    height={height}
  />
);
